// extracted by mini-css-extract-plugin
export var chevron = "_jr-4";
export var chevronExpanded = "_jr-5";
export var row = "_jr-0";
export var rowBody = "_jr-6";
export var rowDescription = "_jr-7";
export var rowHeader = "_jr-1";
export var rowTitle = "_jr-2";
export var rowTitleComplete = "_jr-3";